// ORD-NAMES-2 · the ONE way into the Names department from outside Orders: put `?tab=orders&names=1`
// in the address, then open the Orders portal. Orders reads the flag on mount (useNamesRoute) and shows
// Names. Used by the Home card (homeNavigation) and the cold link (useNamesLinkOpen).
export function openNamesAddress(browser) {
  try {
    const b = browser || window;
    const u = new URL(b.location.href);
    u.searchParams.set('tab', 'orders');
    u.searchParams.set('names', '1');
    b.history.replaceState(b.history.state, '', u.toString());
  } catch (_) { /* no address bar (tests) */ }
}
